import { _ } from "core-js"
import Vue from "vue"

const state = {
    view: 'table',
    paginatedTasks: {
        data: []
    },
    calendarTasks: [],
}

const getters = {
    getView: state => {
        return state.view
    },
    getCalendarTasks: state => {
        return state.calendarTasks
    },
    getPaginatedTasks: state => {
        return state.paginatedTasks
    }
}

const mutations = {
    setView(state, payload) {
        state.view = payload
    },
    createTask(state, data) {
        state.paginatedTasks.data.unshift(data)
        state.calendarTasks.unshift(data)
    },
    updateTask(state, data) {
        if (!_.isEmpty(state.paginatedTasks.data)) {
            state.paginatedTasks.data = state.paginatedTasks.data.map(task => (task.id == data.id ? { ...task, ...data } : task))
        }
        if (!_.isEmpty(state.calendarTasks)) {
            state.calendarTasks = state.calendarTasks.map(task => (task.id == data.id ? { ...task, ...data } : task))
        }
    },
    setCalendarTasks(state, payload) {
        state.calendarTasks = payload
    },
    setPaginatedTasks(state, payload) {
        state.paginatedTasks = payload
    },
    deleteTask(state, payload) {
        let tableKey = state.paginatedTasks.data.findIndex((task) => task.id === payload.id)
		Vue.delete(state.paginatedTasks.data, tableKey)
        let calendarKey = state.calendarTasks.findIndex((task) => task.id === payload.id)
		Vue.delete(state.calendarTasks, calendarKey)
    },
}

const actions = {
    setView({ commit }, payload) {
        commit("setView", payload)
    },
    saveTask({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/save-task", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    let create = _.get(payload, 'form.id', false) ? false : true
                    if (create) {
                        commit("createTask", response.data)
                    } else {
                        if (response.data.status_id == 2) {
                            commit("deleteTask", response.data)
                        }
                        commit("updateTask", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    setTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/get-tasks", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    if (payload.paginated) {
                        commit("setPaginatedTasks", response.data)
                    } else if (payload.calendar) {
                        commit("setCalendarTasks", response.data)
                    }
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    toggleCompletion({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/toggle-task-completion", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    commit("deleteTask", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },
    deleteTask({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/delete-task", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    commit("deleteTask", response.data)
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    multiDeleteTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/multi-delete", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    response.data.forEach(task => {
                        commit("deleteTask", task)
                    })
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    multiCloseTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/multi-close", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    response.data.forEach(task => {
                        commit("deleteTask", task)
                    })
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    },

    multiRestoreTasks({ commit }, payload) {
        return new Promise((resolve, reject) => {
            axios.post("/api/tasks/v2/multi-close", payload, {
                headers: { Authorization: `Bearer ${$store.getters.token}` }
            }).then(
                response => {
                    response.data.forEach(task => {
                        commit("deleteTask", task)
                    })
                    resolve(response)
                },
                error => {
                    reject(error)
                }
            )
        })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
